import React from "react";
import {RouteObject} from "react-router-dom";
import ProductRfqQuoteLayout from "../../layout/ProductRfqQuoteLayout/ProductRfqQuoteLayout";

const ProductRfqQuoteRoutes : RouteObject[] = [
    {
        path:'productrfq',
        element:<ProductRfqQuoteLayout/>
    }
]
export default ProductRfqQuoteRoutes;